import i18next from 'i18next';
import React from 'react';
import FilterInputField from '../../../components/TableFilter/ColumnsFilters/FilterInputField';



export function reportsVoucherHoldersColumns({ t, reportVoucherHoldersType }) {
  const currentLang = i18next.language;
  const langNameField = `${currentLang}Name`;

  const columns = [
    {
      Header: '№',
      accessor: 'rowNumber',
      width: 100,
      sortable: true,
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: t('monitoring_columnParentIIN'),
      accessor: 'iin',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="iin" type="number" />
    },
    {
      Header: t('monitoring_columnParentFullName'),
      accessor: 'parentFullName',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="parentFullName" />,
    },
    {
      Header: t('monitoring_columnParentTelephoneNumber'),
      accessor: 'parentTelephoneNumber',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="parentTelephoneNumber" type="number" />
    },
    {
      Header: t('monitoring_columnChildIIN'),
      accessor: 'childIin',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="childIin" type="number" />
    },
    {
      Header: t('monitoring_columnChildFullName'),
      accessor: 'childFullName',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="childFullName" />,
    },
    {
      Header: t('monitoring_columnKatoCode'),
      accessor: 'queuedRegion',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="queuedRegion" type="number"/>,
    },
  ];
  if (reportVoucherHoldersType?.code === 'WAITING_PO') {
    columns.push(
      {
        Header: t('monitoring_columnBinPO'),
        accessor: 'bin',
        style: { textAlign: 'center' },
        Filter: <FilterInputField name="bin" type="number" />
      },
      {
        Header: t('monitoring_columnLangName'),
        accessor: langNameField,
        style: { textAlign: 'center' },
        Filter: <FilterInputField name={langNameField} />,
      }
    );
  }

  return columns;
}